import { Link } from "react-router-dom";
import {
    LESSON_REQUEST_STATUS,
    getOpenedClassReservationPath,
    getOpenedPracticeReservationPath,
} from "constants/lessonRequest";

// 개설/예약된 강습·연습반으로 진입하는 링크. OPENED/CONFIRMED 에서만 노출하고,
// 거절/만료/취소/대기에는 표시하지 않는다. 카드와 상세 모두에서 재사용한다.
const ELIGIBLE_STATUSES = [LESSON_REQUEST_STATUS.OPENED, LESSON_REQUEST_STATUS.CONFIRMED];

const stopPropagation = (event) => event.stopPropagation();

const stopKeyboardPropagation = (event) => {
    if (event.key === "Enter" || event.key === " ") {
        event.stopPropagation();
    }
};

export default function OpenedReservationLinks({ request, className }) {
    if (!request || !ELIGIBLE_STATUSES.includes(request.status)) return null;

    const classPath = getOpenedClassReservationPath(request);
    const practicePath = getOpenedPracticeReservationPath(request);
    if (!classPath && !practicePath) return null;

    const wrapClassName = ["lesson-request-reservation-links", className].filter(Boolean).join(" ");

    return (
        <div className={wrapClassName}>
            {classPath && (
                <Link
                    to={classPath}
                    className="lesson-request-reservation-link"
                    onClick={stopPropagation}
                    onKeyDown={stopKeyboardPropagation}
                >
                    개설된 수업 보기
                </Link>
            )}
            {practicePath && (
                <Link
                    to={practicePath}
                    className="lesson-request-reservation-link"
                    onClick={stopPropagation}
                    onKeyDown={stopKeyboardPropagation}
                >
                    개설된 수업 보기
                </Link>
            )}
        </div>
    );
}
